import { useNavigate } from "react-router-dom";
import { Icon } from "../../modules/icon";
import "./BackButton.style.css";
import { useTranslation } from "react-i18next";

const BackButton = ({ onClick }: { onClick?: (() => void) | boolean }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div
      onClick={() => {
        if (typeof onClick === "function") {
          onClick();
          return;
        }
        navigate(-1);
      }}
      className="back-button"
    >
      <Icon size={16} type={"fa-solid fa-chevron-left"} title={"BACK_BUTTON"} />
    </div>
  );
};

export default BackButton;
